import { electionsQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';

export const useElectionsQuery = () => {
	const { axiosInstance } = useAxiosInstance();

	return usePoQuery({
		queryKey: ['announced-elections'],
		queryFn: () => electionsQuery(axiosInstance),
	});
};
